import { Component, inject, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import {
  CallOutComponent,
  DataAnalyticsTaggingDirective,
  SecurityService,
  OrderSecurity,
  TransfersTab,
  DataAnalyticsTaggingEvent,
  DataAnalyticsTaggingConstants,
  IconComponent
} from '@tdwb/core';

import { DisplayLearnInformation } from '../../domain';
import { TradingLearnModalComponent } from '../trading-learn-modal/trading-learn-modal.component';

@Component({
  selector: 'td-wb-trading-learn-information',
  templateUrl: './trading-learn-information.component.html',
  styleUrls: ['./trading-learn-information.component.scss'],
  imports: [
    DataAnalyticsTaggingDirective,
    CallOutComponent,
    IconComponent,
    TranslateDirective,
    TradingLearnModalComponent
  ]
})
export class TradingLearnInformationComponent {
  private readonly securityService = inject(SecurityService);

  readonly tabId = input<OrderSecurity | TransfersTab>('equity');
  readonly page = input<DisplayLearnInformation>('buysell');

  eventData: DataAnalyticsTaggingEvent;

  showTradingLearnInformation(): boolean {
    return this.securityService.hasPermission('DIRECT_INVESTING');
  }

  setAnalytics(): void{
    this.eventData =
      DataAnalyticsTaggingConstants.getLinkClickEventData('tdw:wbt:ofi:transfer:learn now');
  }
}
